import React from 'react'
import { Input } from '@smooth-ui/core-em'

const InputCustom = props => {
  return (
    <Input backgroundColor="gray100" height="50" {...props}>
      {props.children}
    </Input>
  )
}

export default InputCustom



// WEBPACK FOOTER //
// ./src/UILibrary/Input.js